import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  notificationId: yup.number().required(),
  wpuId: yup.number().required(),
});

export function useIntroNotificationAcknowledgeMutation(options = {}) {
  return useMutation((dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });

    return http.post(HTTP_ENDPOINTS.introNotification.acknowledge(), req);
  }, options);
}
